<template>
  <div class="info-table-height">
    <table class="table table-hover table-border">
      <caption class="table-caption caption-fix">
        <span class="little-title caption-title-fix">{{ tableTitle }}</span><a href="purchase.html"
                                                             class="pull-right bid-info-span">更多&gt;</a>
        <!-- 非采购组织的list -->
        <ul class="list-basic-settings classify-List" :class="{showall}" v-if="tableTitle != '按采购组织'">
          <li v-for="(item,index) in tableContent"><span class="bid-info-span" @click="toggle(index)"
                                                         :class="{active: active == index}">{{ item }}</span></li>
        </ul>
        <div class="updown" v-if="tableTitle != '按采购组织'"><i class="fa fa-angle-down" @click="updown()"></i></div>

        <!-- 采购组织的list -->
        <!-- 层次先定三层，后续加 -->
        <template v-if="tableTitle == '按采购组织'">
          <div class="orgList" @mouseleave="updown_org(false)" @mouseenter="updown_org(true)">
            <div>
              <span>{{name}}</span>
              <span class="updown_org"><i class="fa fa-angle-down"></i></span>
            </div>
            <div class="content-wrap" v-if="show" @mouseleave ="setInnerContent(false)" @mouseenter="setInnerContent(true)">
              <div class="content animated fadeIn" >
                  <ul>
                    <li v-for="item in c1" :class="{orgSelect:c1ItemId==item.id}" :title="item.orgName" @click="orgClick(item.orgName)" @mouseenter="setC2(item.id,$event)">{{item.orgName}}</li>
                  </ul>
              </div>
              <div class="content animated fadeIn" :class="{orgBorder:c2.length>0}" :key="c2.length">
                  <ul>
                    <li v-for="item in c2" :class="{orgSelect:c2ItemId==item.id}" :title="item.orgName" @click="orgClick(item.orgName)" @mouseenter="setC3(item.id,$event)">{{item.orgName}}</li>
                  </ul>
              </div>
              <div class="content animated fadeIn" :class="{orgBorder:c3.length>0}" :key="c3.length">
                  <ul>
                    <li v-for="item in c3" :class="{orgSelect:c3ItemId==item.id}" :title="item.orgName" @click="orgClick(item.orgName)" @mouseenter="setC4(item.id,$event)">{{item.orgName}}</li>
                  </ul>
              </div>
              <div class="content animated fadeIn" :class="{orgBorder:c4.length>0}" :key="c4.length">
                  <ul>
                    <li v-for="item in c4" :class="{orgSelect:c4ItemId==item.id}" :title="item.orgName" @click="orgClick(item.orgName)" @mouseenter="setC5(item.id,$event)">{{item.orgName}}</li>
                  </ul>
              </div>
            </div>
          </div>
        </template>

      </caption>
      <tbody class='show-limit'>
      <template v-if="infos && infos instanceof Array">
        <tr v-for="info in infos" class="normal" @click="seeDetails(info)">
          <td>
            <template v-if="info.messageType == '招标公告'">
              <span class="state state-bid">{{info.messageType}}</span>
            </template>

            <template v-else-if="info.messageType == '招标'">
              <span class="state state-enquiry">{{info.messageType}}</span>
            </template>

            <template v-else-if="info.messageType == '中标通知'">
              <span class="state state-bidding">{{info.messageType}}</span>
            </template>

            <template v-else>
              <span class="state state-other">{{info.messageType}}</span>
            </template>
          </td>
          <td  class="limitText" :title="info.messageTitle">
            <div class="setMargin">{{info.messageTitle}}</div>
          </td>
          <td class="limitText" :title="info.purOrgName">
            <div class="setMargin">{{info.purOrgName}}</div>
          </td>
          <td  class="limitText" :title="info.messageContent">
            <div class="setMargin">{{ datatype=="area" ? info.purOrgName : info.messageContent}}</div>
          </td>
          <!--<button class="btn action btn-details" @click="seeDetails(info)">查看详情</button>-->
          <template v-if="info.status">
            <td  class="btn-action">
              <template v-if=" info.status==='1' ">
                <span>报名未开始</span>
              </template>
              <template v-else-if=" info.status==='3' ">
                <span>报名已结束</span>
              </template>
              <template v-else-if=" info.status==='4' ">
                <span>报名已结束</span>
              </template>
              <template v-else-if=" info.status==='5' ">
                <span>报名已结束</span>
              </template>
              <template v-else-if=" info.status==='-1' ">
                <span>招标已结束</span>
              </template>
              <template v-else>
                <span>报名进行中</span>
              </template>
            </td>
          </template>
          <template v-else>
            <td  class="btn-action">
              <template v-if=" now < timeFormat(info.publishTime) ">
                <span>报名未开始</span>
              </template>
              <template v-else-if=" now > timeFormat(info.deadline) ">
                <span>报名已结束</span>
              </template>
              <template v-else>
                <span>报名进行中</span>
              </template>
            </td>
          </template>
          <td  class="td-text-right"><span id="setMargin">截止时间：<br>{{info.deadline}}</span></td>
        </tr>
        <template v-if="infos.length < 6">
          <tr v-for="info in (6-infos.length)" class="supplement">
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </template>
      </template>
      <template v-else>
        <p class="error-handling">暂无数据</p>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
  /*eslint-disable*/
  import {apiLinks} from '../api/links.js'
  import _ from 'lodash'

  export default {
    name: 'infotable',
    data () {
      return {
        materialList: [],
        innercode: [],
        orgName: [],
        now: new Date().getTime(),
        active: '',
        infos: '',
        status: '',
        url: '',
        currentPageUrl: apiLinks.infoTable[this.which][0],
        showall: false,
        // 1号数据,固定数据
        c1:[],
        //2号数据
        c2:[],
        //3号数据
        c3:[],
        //4号数据
        c4:[],
        org:{},
        c1ItemId:'',
        c2ItemId:'',
        c3ItemId:'',
        c4ItemId:'',
        //是否在导航上
        innerNav:false,
        //是否在内容区域
        innerContent:false,
        name:''
      }
    },
    props: {
      tableTitle: '',
      tableContent: '',
      which: '',
      datatype: ''
    },
    created: function () {
      if (this.tableTitle === '按类别查看') {
        this.fetchMateriaClass()
      }
      this.getCustomers(this.currentPageUrl)
      this.fetchOrgClass()
      this.name='请选择组织机构'
    },
    filters: {
      cutStr: function (str) {
        if (!str) return ''
        let abortDate = ''
        abortDate = str.split('-')
        let abortDay = ''
        abortDay = abortDate[abortDate.length - 1].split(' ')
        return abortDate[0] + '年' + abortDate[1] + '月' + abortDay[0] + '日'
      }
    },
    computed:{
      show(){
        return this.innerNav||this.innerContent;
      }
    },
    methods: {
      orgClick: function (orgName) {
        this.name=orgName
        this.currentPageUrl = apiLinks.infoTable['type'][0]
        this.currentPageUrl += ('&purOrgName=' + orgName)
        this.getCustomers(this.currentPageUrl)
        $('.updown_org i').removeClass('fa-angle-up');
        $('.updown_org i').addClass('fa-angle-down');
        $('.orgList').removeClass('orgTitleSelect');
        this.innerNav=false;
        this.innerContent=false;
      },
      setInnerContent(val){
        this.innerContent=val;
      },
      setC2:_.debounce(function(id){
        this.c1ItemId=id;
        if(id!=-1){
          var ct = _.filter(this.org,{'parentId':id})
          var list = []
          for(var i = 0;i<ct.length;i++){
            list.push({orgName:ct[i].orgName,id:ct[i].id})
          }
          if(list.length){
            this.c2=list
            this.c3=[];
          }else{
            this.c2=[];
            this.c3=[];
          }
        }
      },200),
      setC3:_.debounce(function(id){
        this.c2ItemId=id;
        if(id!=-1){
           var ct = _.filter(this.org,{'parentId':id})
           var list = []
           for(var i = 0;i<ct.length;i++){
             list.push({orgName:ct[i].orgName,id:ct[i].id})
           }
           if(list.length){
            this.c3=list
           }else{
            this.c3 = []
           }
        }
      },200),
      setC4:_.debounce(function(id){
        this.c3ItemId=id;
        if(id!=-1){
           var ct = _.filter(this.org,{'parentId':id})
           var list = []
           for(var i = 0;i<ct.length;i++){
             list.push({orgName:ct[i].orgName,id:ct[i].id})
           }
           if(list.length){
            this.c4=list
           }else{
            this.c4= []
           }
        }
      },200),
      setC5:function(id){
        this.c4ItemId=id;
      },
      updown_org:_.debounce(function(obj){
        this.innerNav=obj;
        if(obj){
          $('.updown_org i').removeClass('fa-angle-down');
          $('.updown_org i').addClass('fa-angle-up');
          $('.orgList').addClass('orgTitleSelect');
        }else{
          $('.updown_org i').removeClass('fa-angle-up');
          $('.updown_org i').addClass('fa-angle-down');
          $('.orgList').removeClass('orgTitleSelect');
        }
      },200),
      fetchOrgClass: function () {
        this.$http.jsonp(apiLinks.orgClass, []).then(function(response) {
          this.org = response.body[0].result
          if(this.org){
            // var ct = _.filter(this.org,{'parentId':0})
            var ct = this.org
            if(ct.length){
              var list = []
              for(var i = 0;i<ct.length;i++){
                list.push({orgName:ct[i].orgName,id:ct[i].id})
              }
              this.c1 = list
            }else{
              this.c1 = [{orgName:'无数据',id:-1}]
            }
          }else{
            this.c1 = [{orgName:'无数据',id:-1}]
          }
        }, function(response) {
          console.log(0)
        })
      },
      nowUrl: function () {
        this.url = window.location.href
      },
      toggle: function (index) {
        this.active = index
        this.currentPageUrl = apiLinks.infoTable[this.which][0]
        if (this.datatype === 'area' && this.tableContent[index] !== '全部') {
          this.currentPageUrl += ('&purOrgName=' + this.tableContent[index])
        }
        if (this.datatype === 'type' && this.tableContent[index] !== '全部') {
          this.currentPageUrl += ('&innercode=' + this.innercode[index - 1])
        }
        if (this.datatype === 'orgName' && this.tableContent[index] !== '全部') {
          this.currentPageUrl += ('&purOrgName=' + this.tableContent[index])
        }
        this.getCustomers(this.currentPageUrl)
      },
      generateMaterialTree () {
        // 之前数据太多了 现在就不过滤了
        let list = _.filter(this.materialList, function (data) {
          return data.parentid === 0
        })
        // let list = this.materialList
        for (let i = 0; i < list.length; i++) {
          this.tableContent.push(list[i].className)
          this.innercode.push(list[i].innercode)
          // this.innercode.push(list[i].id)
        }
        this.$nextTick(() => {
          if($(this.$el).find('.list-basic-settings').height()>46){
            $(this.$el).find('.updown').show();
            $(this.$el).find('.classify-List').css('height','46px')
          }
        })
      },
      fetchMateriaClass: function () {
        this.$http.jsonp(apiLinks.materiaClass+0, []).then(function (response) {
          let data = response.body[0]
          if (data.status === 1) {
            this.materialList = data.data
            this.generateMaterialTree()
          }
        }, function (response) {
          console.log(0)
        })
      },
      getCustomers: function (url) {
        this.$http.jsonp(url, []).then(function (response) {
          this.infos = response.data[0]['result']
          this.status = response.status
        }, function (response) {
          console.log(0)
        })
      },
      seeDetails: function (info) {
        let url = ''
        var status = parseInt(info.messageState)
        // 数据有问题 先定死成招标公告
        status = 4
        if (info.messageTypeShow === '0') {
          status = 0
        }
        switch (status) {
//        询价
          case 0:
            url = apiLinks.details['inquiryDetails'] + info.msgId
            break
          case 1:
            url = apiLinks.details['bidDoc'] + info.msgId
            break
//        招标公告
          case 4:
            url = apiLinks.details['bidDetails'] + info.msgId
            break
          case 5:
            url = apiLinks.details['bidNotice'] + info.msgId
            break
          default:
            break
        }
        if (url !== '') {
          var portaltype = window.localStorage.portaltype
          window.open(url+'&from=' + portaltype)
        }
      },
      timeFormat: function (str) {
        return new Date(Date.parse(str.replace(/-/g, '/'))).getTime()
      },
      updown: function () {
        if(this.showall){
          this.showall = false;
          $(this.$el).find('.updown i').removeClass('fa-angle-up');
          $(this.$el).find('.updown i').addClass('fa-angle-down');
        }else{
          this.showall = true;
          $(this.$el).find('.updown i').removeClass('fa-angle-down');
          $(this.$el).find('.updown i').addClass('fa-angle-up');
        }
      }
    }
  }
</script>

<style lang="less">
  @import '../assets/base.less';
  .caption-fix {
    position: relative;
  }
  .caption-fix .caption-title-fix {
    position: absolute;
    top: 10px;
  }

  .info-table-height {
    min-height: 392px;
  }

  .classify-List {
    /*display: inline-flex;*/
    display: inline-block;
    overflow: hidden;
  }

  .table-caption > span {
    position: relative;
    top:-5px;
  }

  .table-caption > ul {
    position: relative;
    top: 7px;
    width: 75%;
  }

  /*:root .classify-List {*/
  /*display: inline-block;*/
  /*}*/

  .btn-action {
    text-align: center;
  }

  .btn-action > button {
    width: 80px;
  }

  .btn-details {
    background-color: #F6F6F6;
    color: #555555;
    border: 1px solid #DDDDDD;
    padding: 4px 10px !important;
    margin-left: 13px;
  }

  td.limitText{
    max-width: 200px;
  }

  .limitText > div {
    white-space: nowrap;
    /*显示省略符号来代表被修剪的文本*/
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }

  .table-border {
    min-height: 307px;
  }

  .table-border td {
    height: 57px;
  }

  .error-handling {
    margin-top: 130px;
    text-align: center;
  }

  .state {
    display: inline-block;
    padding: 0 8px;
    /*height: 20px;*/
    text-align: center;
  }

  .state-bid {
    border: 1px solid #92B8E0;
    color: #639cd7;
  }

  .state-enquiry {
    border: 1px solid #FD9B31;
    color: #F58000;
  }

  .state-bidding {
    border: 1px solid @primary;
    color: @primary;
  }

  .state-other {
    border: 1px solid #339966;
    color: #339966;
  }

  .show-limit > tr {
    height: 51px;
  }

  .table-hover > tbody > .supplement:hover {
    background-color: #FFFFFF;
  }

  .table-hover > tbody > .supplement:first-child {
    border-top: 1px solid #ddd;
  }

  .supplement > td {
    border: none !important;
  }

  .supplement:first-child {
    border-bottom: 1px solid #ddd;
  }

  tr.normal {
    cursor: pointer;
  }

  .td-text-right > span {
    display: inline-block;
    margin-left: 25px;
  }
  .table-type ul > li{
    margin-bottom: 5px;
  }
  .table-orgName ul > li{
    margin-bottom: 5px;
  }
  .active{
    padding-bottom: 2px;
  }
  .bid-info-span:hover{
    padding-bottom: 2px;
  }
  .table-orgName ul {
    margin-left: 73px;
  }
  .updown{
    display: none;
    text-align: center;
    height: 20px;
  }
  .fa {
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transform: translate(0, 0);
    font-size: 17px;
  }
  .fa, .fa-stack {
    display: inline-block;
  }
  .fa-angle-down:before {
    content: "\f107";
  }
  .fa-angle-up:before {
    content: "\f106";
  }
  .showall{
    height: auto!important;
  }
  .orgList{
    padding:5px;
    display: inline-block;
    margin-left: 20px;
    font-size: 16px;
  }
  .updown_org{
    margin-left: 5px;
    text-align: center;
    height: 20px;
  }
  .content-wrap {
    position: absolute;
    z-index: 2;
    padding: 10px;
    padding-left: 0;
    background: white;
    margin-left: -6px;
    margin-top: 5px;
    border: 1px solid #ccc;
    font-size: 13px;
  }

  .content-wrap .content {
    display: inline-block;
    vertical-align: top;
  }

  .content-wrap .content li {
    position: relative;
    list-style-type: none;
    padding:3px;
  }

  .content-wrap .content li:after{
    content:'>';
    position: absolute;
    right: 0;
  }

  .animated {
    animation-duration: 1s;
    animation-fill-mode: both;
    z-index: 100;
  }

  @keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
  }

  .fadeIn {
      animation-name: fadeIn;
  }

  .orgList .content-wrap .content ul{
    margin-left:0px;
  }

  .orgList .content-wrap .content ul li{
    padding: 10px;
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .orgTitleSelect{
    background-color: white;
    border: 1px solid #ccc;
    margin-top:-1px;
    margin-bottom:-1px;
  }

  .orgSelect{
    background-color: #C4EAF6;
  }

  .orgBorder{
    border-left: 1px solid #ccc;
  }
</style>



// WEBPACK FOOTER //
// info-table.vue?6830f478